import { useMemo } from "react";

import { ErrorMessage } from "@/app/components/error-message";
import { LoadingScreen } from "@/components/loading-screen";
import { SearchBar } from "@/components/search-bar";
import { useTableControl } from "@/components/table-control";
import { useFetchEventCategories } from "@/features/event-categories/api/fetch-event-categories";
import { CreateEventCategoryForm } from "@/features/event-categories/components/create-event-category-form";
import { EventCategoriesTable } from "@/features/event-categories/components/event-categories-table";
import { OnboardingHeader } from "@/features/registration/components/onboarding-header";
import { useOrganisation } from "@/features/select-organisation/api/get-my-organisation";

export function EventCategoriesPage() {
  const { search, setSearch } = useTableControl();
  const { organisation } = useOrganisation();

  const {
    data: eventCategoriesData,
    isLoading,
    isSuccess,
    isError,
    isFetching,
    isPlaceholderData,
    error,
  } = useFetchEventCategories({
    organisationId: organisation.id,
  });

  const filteredData = useMemo(() => {
    if (!eventCategoriesData) return [];

    return eventCategoriesData.filter((eventCategory) =>
      eventCategory.name.toLowerCase().includes(search?.toLowerCase() ?? ""),
    );
  }, [eventCategoriesData, search]);

  if (isLoading)
    return (
      <div>
        <OnboardingHeader
          title="Event Categories"
          description="View and manage Event Categories"
          className="mb-6"
        />
        <LoadingScreen />
      </div>
    );

  if (isError || !isSuccess)
    return (
      <div>
        <OnboardingHeader
          title="Event Categories"
          description="View and manage Event Categories"
          className="mb-6"
        />
        <ErrorMessage error={error} />
      </div>
    );
  return (
    <section>
      <OnboardingHeader
        title="Event Categories"
        description="View and manage Event Categories"
        className="mb-6"
      />
      <div className="mb-2 justify-between sm:flex">
        <SearchBar
          search={search}
          setSearch={setSearch}
          className="mb-2 sm:mb-0 sm:max-w-xs"
        />
        <CreateEventCategoryForm organisationId={organisation.id} />
      </div>
      <EventCategoriesTable
        data={filteredData}
        isLoading={isFetching && isPlaceholderData}
        organisationId={organisation.id}
      />
    </section>
  );
}
